import { TCategory } from "../types/types"

export const categories: Array<TCategory> = [
  {
    categoryMarker: 'bun',
    ruCategoryName: 'Булки',
  },
  {
    categoryMarker: 'sauce',
    ruCategoryName: 'Соусы',
  },
  {
    categoryMarker: 'main',
    ruCategoryName: 'Начинки',
  }
]
